module.exports = __webpack_public_path__ + "static/media/gingerbread-man.0ed7097b.svg";